import React, { FC } from 'react' // @ts-ignore
import cx from 'classnames'
import styles from './FAQ.module.scss'
import SlideDown from 'components/SlideDown'
import { Heading } from 'components/basic/Heading'
import { MEMBERSHIP_FAQ_ITEM } from 'components/_sections/FAQ/_faqs'

interface FAQProps {
	hideMembership?: boolean
}

export const FAQ: FC<FAQProps> = (props) => {
	return (
		<section className={cx(styles.section, 'inner-paddings-x inner-paddings-y')}>
			<div className={cx(styles.content, 'max-1440')}>
				<div className={styles.title}>
					<Heading
						type="h2"
						title="FAQs"
					/>
				</div>
				<div className={styles.faq}>
					{/* <SlideDown
						top={<p className={styles.question}>Which Eight Sleep products are available in the EU?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>The Pod 3 Cover is available in Europe in three sizes: Double (135x190 cm), Large Double (160x200 cm), and Grand King (180x200 cm).</p>
					</SlideDown> */}
					<SlideDown
						top={<p className={styles.question}>Do I pay for shipping, duties and returns?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>Shipping, duties and returns are free.</p>
					</SlideDown>
					<SlideDown
						top={<p className={styles.question}>Can I try the Pod Cover?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>
							The Pod Cover comes with a 30 night trial, so you can try it at home and decide if it's the right fit for you. If you don't love it, return it within 30 nights from delivery for a full
							refund.
						</p>
					</SlideDown>
					{/* <SlideDown
						top={<p className={styles.question}>Will delivery be available for all of Europe?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>The Pod 3 Cover is available for delivery in: {Object.keys(getEUShippingCountries()).join(', ')}.</p>
					</SlideDown>
					<SlideDown
						top={<p className={styles.question}>What payment and financing options are available?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>For European members, credit card payment is the only option available for the time being.</p>
					</SlideDown>
					<SlideDown
						top={<p className={styles.question}>Is the Eight Sleep app available in Europe?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>Yes, the Eight Sleep app is available on Apple and Android App stores internationally. </p>
					</SlideDown>
					<SlideDown
						top={<p className={styles.question}>What do I get with the 8+ Pro membership?</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>
							The optional 8+ Pro membership adds additional digital features to further improve your sleep, including Autopilot, digital coaching and data insights, and sleep content, as well as
							discounts on accessories and upgrades.
						</p>
					</SlideDown> */}
					<SlideDown
						top={<p className={styles.question}>{MEMBERSHIP_FAQ_ITEM.question}</p>}
						className={styles.question_container}
					>
						<p className={styles.answer}>{MEMBERSHIP_FAQ_ITEM.answer}</p>
					</SlideDown>
				</div>
			</div>
		</section>
	)
}
